/* eslint-env browser */ // Es-lint directive
import React, { Suspense } from 'react'
import { Provider } from 'react-redux'
import * as Sentry from '@sentry/react'
import { BrowserTracing } from '@sentry/tracing'
import { createRoot } from 'react-dom/client'

import { storeInstance } from './redux/store'
import reportWebVitals from './ReportWebVitals'
import App from './App'
import './assets/styles/scss/index.module.scss'
import './i18n'
import Loader from 'components/Shared/Loader'

if (process.env.REACT_APP_ENV !== 'development') {
  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DSN,
    integrations: [new BrowserTracing()],
    environment: process.env.REACT_APP_ENV,
    // trace sample rate - used to measure the performance of the application we have removed it temporarily till
    // we reduce the transaction rate
  })
}

const container = document.getElementById('root') as HTMLElement
const root = createRoot(container)
root.render(
  <>
    <Suspense fallback={<Loader />}>
      <Provider store={storeInstance}>
        <React.StrictMode>
          <App />
        </React.StrictMode>
      </Provider>
    </Suspense>
  </>,
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
